'use strict';

const url = require('url');

function separatePathToComponents(pathString) {
  const result = pathString.split('/');
  const lastIndex = result.length - 1;
  const lastEntry = result[lastIndex];
  if (lastEntry.includes('.')) {
    result[lastIndex] = lastEntry.replace(/([^.]*)\.(html|md)$/, '$1');
  }

  return result;
}

class Url {
  constructor(urlObject) {
    this.urlObject = urlObject;
    this.path = urlObject.pathname;
  }

  toString() {
    return url.format(this.urlObject);
  }
}

module.exports = class ResourceLocator {
  constructor(pathString) {
    this.components = separatePathToComponents(pathString);
  }

  slice(begin, end) {
    const copy = new ResourceLocator('');
    copy.components = this.components.slice(begin, end);

    return copy;
  }

  src(prefix, suffix) {
    let result = '';

    prefix = prefix || '';
    suffix = suffix || '.md';

    let path = [];
    if (prefix) {
      path = path.concat(separatePathToComponents(prefix));
    }
    path = path.concat(this.components);

    result = path.join('/');
    if (!result.endsWith('/')) {
      result += suffix;
    }

    return result;
  }

  dist(prefix, suffix) {
    let result = '';

    prefix = prefix || '';
    suffix = suffix || '.html';

    let path = [];
    if (prefix) {
      path = path.concat(separatePathToComponents(prefix));
    }
    path = path.concat(this.components);
    if (path.length === 2 && path[path.length - 1] === 'top') {
      path[path.length - 1] = 'index';
    }

    result = path.join('/');
    if (result.endsWith('/')) {
      result += 'index';
    }
    result += suffix;

    return result;
  }

  url(hostname, suffix) {
    hostname = hostname || 'kamigame.jp';
    suffix = suffix || '.html';

    const path = [].concat(this.components);
    if (path.length === 2 && path[path.length - 1] === 'top') {
      path[path.length - 1] = 'index';
    }

    let pathString = `/${path.map((v) => encodeURIComponent(v)).join('/')}`;
    if (pathString.endsWith('/')) {
      pathString += 'index';
    }
    pathString += suffix;

    return new Url({
      hostname,
      protocol: (hostname === 'kamigame.jp') ? 'https:' : 'http:',
      pathname: pathString,
    });
  }
};
